import axios from 'axios'
import * as config from '../config'

export const REPORT_REQUEST = "REPORT_REQUEST"
export const REPORT_SUCCESS = "REPORT_SUCCESS"
export const REPORT_ERROR = "REPORT_ERROR"
export const REPORT_CHANGEFIELD = "REPORT_CHANGEFIELD"
export const REPORT_CHANGESETTINGS = "REPORT_CHANGESETTINGS"
export const REPORT_RESET = "REPORT_RESET"

export function Get(id){
    return (dispatch) =>{
        dispatch({
            type:REPORT_REQUEST
        })

        axios.get(
            config.apiUrl + "/report/" + id
        )
        .then((response)=>{
            dispatch({
                type:REPORT_SUCCESS,
                payload:response.data
            })
        })
        .catch((err)=>{
            dispatch({
                type:REPORT_ERROR
            })
        })
    }
}

export function ChangeField(field,value){
    return (dispatch)=>{
        dispatch({
            type:REPORT_CHANGEFIELD,
            payload:{
                field,
                value
            }
        })
    }
}

export function ChangeSettings(field,value){
    return (dispatch)=>{
        dispatch({
            type:REPORT_CHANGESETTINGS,
            payload:{
                field,
                value
            }
        })
    }
}

export function Reset(){
    return(dispatch)=>{
        dispatch({
            type:REPORT_RESET
        })
    }
}




// WEBPACK FOOTER //
// ./src/actions/reportActions.js